import styled from 'styled-components';

export const Card = styled.div`
    border: 1px solid #b1c3c5;
    width: 50%;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-top: 10px;
    padding-bottom: 10px;
    max-width:500px;

    @media (max-width: 768px) {
        width: 100%;
        flex-direction: column;
        padding: 10px 0px;
        margin-bottom: 20px;
    }
`;

export const FeatureText = styled.div`
   width: 60%;
   text-align: justify;
   margin: 0px 15px 15px;

   @media (max-width: 768px) { 
         width: 90%;
         margin: 0px 15px 15px;
         text-align: center;
    }
   `; 
   

export const FeatureImage = styled.img`
    width: ${(props) => (props.widthImage ? props.widthImage : '40%')};
    margin-left: 15px;   
    max-height: 180px;
    @media (max-width: 768px) {
        width: 100%;
        margin-left: 0px;
        margin-bottom: 10px;
    }
`;

export const FeatureButton = styled.button`  
      background-color: #051532;
      color: white;
      padding: 8px 15px;
      border: none;
      border-radius: 8px;
      font-size: 14px;
      cursor: pointer;
      font-weight: 500;
      font-family: "Open Sans";
      text-decoration: none;
      margin-top: 5px;
` ;

export const FeatureTitle = styled.div`
    font-weight: bold;
    margin-bottom: 8px;
    color: #444444;C
    font-size: 16px;
    line-height: 28px;
    font-family: "Open Sans";
`;

export const FeatureDescription = styled.div`
 color: #444444;
 margin-bottom: 20px;
 font-size: 16px;
 line-height: 19px;
 font: "Open Sans";
`;